import { createStateHook } from '@restate/core'
import { AppStoreProvider } from '../../state/store'

export const useDashboardState = createStateHook(
  AppStoreProvider,
  state => state.pages.dashboard
)
